module.exports = __webpack_public_path__ + "static/addsnippet-fc3f300effc2a141d9a1c6359abb3757.png";